/**
 * @generated SignedSource<<2ad71aec50ef5807d8f1b09a327a56e6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "documentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "externalId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "top",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "right",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bottom",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "left",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "Padding",
  "kind": "LinkedField",
  "name": "padding",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    (v2/*: any*/),
    (v3/*: any*/),
    (v4/*: any*/)
  ],
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "breakPage",
  "storageKey": null
},
v7 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "action",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "DocumentWidgetRuleCondition",
    "kind": "LinkedField",
    "name": "conditions",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "condition",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "variable",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "value",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "operator",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "DocumentWidgetRule",
  "kind": "LinkedField",
  "name": "rules",
  "plural": true,
  "selections": (v7/*: any*/),
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "DocumentWidget",
  "kind": "LinkedField",
  "name": "widgets",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "widgetId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rootWidgetId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    (v8/*: any*/)
  ],
  "storageKey": null
},
v10 = [
  (v9/*: any*/),
  (v5/*: any*/)
],
v11 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "documentId",
        "variableName": "documentId"
      },
      {
        "kind": "Variable",
        "name": "externalId",
        "variableName": "externalId"
      }
    ],
    "concreteType": "DocumentInstance",
    "kind": "LinkedField",
    "name": "documentInstance",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "documentId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "externalId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "teamId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "variables",
        "storageKey": null
      },
      (v5/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "orientation",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "renderingEngineVersion",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DocumentSection",
        "kind": "LinkedField",
        "name": "pages",
        "plural": true,
        "selections": [
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Padding",
            "kind": "LinkedField",
            "name": "padding",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "DocumentWidgetRow",
            "kind": "LinkedField",
            "name": "widgets",
            "plural": true,
            "selections": [
              (v9/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "DocumentWidgetRule",
                "kind": "LinkedField",
                "name": "rulesBreakPage",
                "plural": true,
                "selections": (v7/*: any*/),
                "storageKey": null
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DocumentWidgetHeaderFooter",
            "kind": "LinkedField",
            "name": "header",
            "plural": true,
            "selections": (v10/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DocumentWidgetHeaderFooter",
            "kind": "LinkedField",
            "name": "footer",
            "plural": true,
            "selections": (v10/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "QDocumentInstanceQuery",
    "selections": (v11/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "QDocumentInstanceQuery",
    "selections": (v11/*: any*/)
  },
  "params": {
    "cacheID": "c436b7c6d9554022151c9ca1a587b756",
    "id": null,
    "metadata": {},
    "name": "QDocumentInstanceQuery",
    "operationKind": "query",
    "text": "query QDocumentInstanceQuery(\n  $documentId: ID!\n  $externalId: ID!\n) {\n  documentInstance(documentId: $documentId, externalId: $externalId) {\n    id\n    documentId\n    externalId\n    name\n    teamId\n    variables\n    padding {\n      top\n      right\n      bottom\n      left\n    }\n    orientation\n    renderingEngineVersion\n    pages {\n      breakPage\n      padding {\n        top\n        bottom\n        left\n        right\n      }\n      rules {\n        action\n        conditions {\n          condition\n          variable\n          value\n          operator\n        }\n      }\n      widgets {\n        widgets {\n          widgetId\n          rootWidgetId\n          type\n          rules {\n            action\n            conditions {\n              condition\n              variable\n              value\n              operator\n            }\n          }\n        }\n        breakPage\n        rulesBreakPage {\n          action\n          conditions {\n            condition\n            variable\n            value\n            operator\n          }\n        }\n        padding {\n          top\n          right\n          bottom\n          left\n        }\n      }\n      header {\n        widgets {\n          widgetId\n          rootWidgetId\n          type\n          rules {\n            action\n            conditions {\n              condition\n              variable\n              value\n              operator\n            }\n          }\n        }\n        padding {\n          top\n          right\n          bottom\n          left\n        }\n      }\n      footer {\n        widgets {\n          widgetId\n          rootWidgetId\n          type\n          rules {\n            action\n            conditions {\n              condition\n              variable\n              value\n              operator\n            }\n          }\n        }\n        padding {\n          top\n          right\n          bottom\n          left\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

node.hash = "ff53dc9a0bfe91f122df1ed8c5f7e48f";

export default node;
